// extracted by mini-css-extract-plugin
export var animateOpacity = "style-module--animateOpacity--eb43d";
export var earth = "style-module--earth--b7086";
export var farStars = "style-module--farStars--ffef9";
export var hero = "style-module--hero--df5d3";
export var midStars = "style-module--midStars--d0994";
export var mun = "style-module--mun--ee155";
export var nearStars = "style-module--nearStars--96d2c";
export var paused = "style-module--paused--b73cd";
export var playPause = "style-module--playPause--2c365";